export const BasePath = '/admin';

export const PermissionClientAdminRead = 'clientadmin:read';
export const PermissionClientAdminWrite = 'clientadmin:write';
